import { useRouter } from 'next/router';
import { FC, useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import SEOTags from '~/components/SEOTags';
import { PATH } from '~/constants/enum';
import Layout from '~/layouts/ThemeLayout';
import userAtom from '~/services/user/user.atom';
import styles from '~/styles/pages/Auth.module.scss';
import { getPageStruct, renderPage } from '~/utils/page';
import { getTheme } from '~/utils/theme';

const SignIn: FC = () => {
    const pageStruct = getPageStruct(getTheme(), 'sign-in');

    const router = useRouter();

    const [component, setComponent] = useState<any>();

    useEffect(() => {
        async function fetchComponent() {
            const component = await renderPage(
                pageStruct.children.sort((a: any, b: any) => a.order - b.order),
                getTheme()
            );
            setComponent(component.filter((c) => !!c));
        }

        fetchComponent();
    }, [pageStruct.children]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const token = localStorage.getItem('token');
            if (!!token) {
                router.push(PATH.ProfileInformation);
            }
        }
    }, []);

    return (
        <Layout>
            <SEOTags title="Sign in" />
            <div className={styles.homepage}>{component}</div>
        </Layout>
    );
};

export default SignIn;
